import api from "./index";
import { axios } from '@/utils/request';
import { deleteAction } from "./manage";
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */

export function login(parameter) {
  return axios({
    url: '/auth/login',
    method: 'post',
    data: parameter
  });
}
export function phoneLogin(parameter) {
  return axios({
    url: '/sys/phoneLogin',
    method: 'post',
    data: parameter
  });
}
export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  });
}
export function getInfo() {
  return axios({
    url: '/api/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/js;charset=UTF-8'
    }
  });
}
export function logout(logoutToken) {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/js;charset=UTF-8',
      'X-Access-Token': logoutToken
    }
  });
}
export function unbindWechat(params) {
  return deleteAction('/auth/unbindWechat', params);
}